/* eslint-disable */
import { Box } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useReportContext } from '../../../../base/components/reports/ReportLayout';
import { LIST_REPORTS } from '../../report-detail-player.list';
import Empty from '../../../../base/components/empty';
import OverallTable from './OverallTable';
import PrepaidTable from './PrepaidTable';
import StandardTable from './StandardTable';
import { REPORT_TYPES } from '../../../../constant';

const DetailPlayerReportResults = () => {
  const { data, loading: loadingAllData } = useReportContext();
  const { appliedFilters } = useReportContext();
  const reportType = appliedFilters?.type;

  const hasNoData = useMemo(() => {
    const totalTableNoData = Object.values(data).reduce((totalNoDataTable, table) => {
      if (!table?.total && Array.isArray(table?.data)) {
        return totalNoDataTable + 1;
      }
      return totalNoDataTable;
    }, 0);
    return totalTableNoData === LIST_REPORTS.length && !loadingAllData;
  }, [data, loadingAllData]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        gap: 24,
      }}
    >
      {hasNoData ? (
        <Empty />
      ) : (
        <>
          {reportType === REPORT_TYPES.OVERALL && <OverallTable />}
          {[REPORT_TYPES.OVERALL, REPORT_TYPES.PREPAID].includes(reportType) && <PrepaidTable />}
          {[REPORT_TYPES.OVERALL, REPORT_TYPES.STANDARD].includes(reportType) && <StandardTable />}
        </>
      )}
    </Box>
  );
};

export default DetailPlayerReportResults;
